const config = {
    apiUrl: "https://app.swalookcrm.in",
    // apiUrl: "https://swalook.pythonanywhere.com",
};

export default config;
